/**
 * SSO token provider: allows the API client to obtain the current Azure AD access token
 * when the user signed in via SSO. Set by MsalProvider when the app mounts.
 */
let ssoTokenGetter: (() => Promise<string | null>) | null = null;

export function setSsoTokenGetter(getter: (() => Promise<string | null>) | null): void {
  ssoTokenGetter = getter;
}

export async function getSsoToken(): Promise<string | null> {
  if (!ssoTokenGetter) return null;
  try {
    return await ssoTokenGetter();
  } catch {
    return null;
  }
}
